import { Inject, Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class AppConfig {
  private config: Object = null;
  constructor(private http: HttpClient) {}

  /**
   * Use to get the data found in the config file
   */
  public getConfig(key: any) {
    return this.config[key];
  }

  public load() {
    /*return new Promise((resolve) => {
          this.http.get('../assets/config/config.json').pipe(map(res => res))
                        .subscribe((responseData) => {
                            this.config = responseData;
                            resolve(true);
                        });
                    });  */
    //multi frontend : this is to make ensure that the correct relative config.json is used
    return new Promise((resolve) => {
      // Get the current sub-path (e.g., 'client1' or 'client2')
      const pathArray = window.location.pathname.split("/");
      const subPath = pathArray.length > 1 ? pathArray[1] : ""; // Detect sub-path from URL
      //const configUrl = (window.location.port && window.location.hostname == "localhost") ? '../assets/config/config.json' : `/${subPath}/assets/config/config.json`; // Build URL dynamically
      const configUrl = "../assets/config/config.json"; //Single frontend

      // Fetch the config.json file from the correct sub-path
      this.http
        .get(configUrl)
        .pipe(map((res) => res))
        .subscribe(
          (responseData) => {
            this.config = responseData;
            resolve(true);
          },
          (error) => {
            console.error(`Could not load config from ${configUrl}`, error);
            resolve(false);
          }
        );
    });
  }
}
